// Effective sale name: a per-site custom name (sales.custom_name) overrides
// the parent's week name. Falls back to "" when neither is present.
export const saleName = (sale) => sale?.custom_name || sale?.parent?.week || "";
